import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "@/config/antd";
import AttendeesTab from "@/pages/event_management/single_sub_event/components/sub_event_attendees_tab/Attendees_Tab";
import ManifestoTab from "@/pages/event_management/single_sub_event/components/sub_event_attendees_tab/Manifesto_Tab";
import LogisticsTab from "@/pages/event_management/single_sub_event/components/sub_event_attendees_tab/Logistics_Tab";
import "@/assets/styles/custom_tabs.css";
import {
  fetchSingleManifesto,
  selectCurrentManifesto,
  selectManifestoLoading,
} from "@/store/redux/slices/manifesto/manifesto_slice";
import { selectSubEvents } from "@/store/redux/slices/event/sub_event_slice";

const AttendeesSection = () => {
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();
  const subEvent = useSelector(selectSubEvents)?.[0]; // Get first sub-event
  const manifesto = useSelector(selectCurrentManifesto);
  const isLoading = useSelector(selectManifestoLoading);

  useEffect(() => {
    if (subEvent?.manifestoID) {
      dispatch(
        fetchSingleManifesto({
          key: "_id",
          value: subEvent.manifestoID,
        })
      );
    }
  }, [dispatch, subEvent?.manifestoID]);

  const items = [
    {
      label: "Attendees",
      key: "1",
      children: <AttendeesTab />,
    },
    {
      label: "Manifesto",
      key: "2",
      children: <ManifestoTab manifesto={manifesto} isLoading={isLoading} />,
    },
    {
      label: "Logistics",
      key: "3",
      children: <LogisticsTab logistics={subEvent?.logistics} />,
    },
  ];

  return (
    <div className="mt-8">
      <Tabs
        defaultActiveKey="1"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        className="custom-tabs"
        tabBarStyle={{
          marginBottom: "24px",
        }}
      />
    </div>
  );
};

export default AttendeesSection;

AttendeesSection.propTypes = {
  members: PropTypes.array,
};
